// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__28Af1","footer":"ModalFilter_footer__jpBbe"};